// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import {getAuth} from 'firebase/auth'
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA8w0QtecCNZpWVu50IPP8HLxXMjor_BOg",
  authDomain: "gadgeting-prod.firebaseapp.com",
  projectId: "gadgeting-prod",
  storageBucket: "gadgeting-prod.appspot.com",
  messagingSenderId: "808618265240",
  appId: "1:808618265240:web:13055197a0216e30981eed",
  measurementId: "G-91N48X71C0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app)